import { render, staticRenderFns } from "./CatalogPagesButton.vue?vue&type=template&id=27370912"
import script from "./CatalogPagesButton.vue?vue&type=script&lang=ts"
export * from "./CatalogPagesButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports